// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-details .patient .table td[data-v-2b4dccc0],.profile-details .patient .table th[data-v-2b4dccc0]{padding:0;line-height:30px}.antech-status-label[data-v-2b4dccc0]{line-height:normal}#lab-display-html-content[data-v-2b4dccc0]{max-width:400px;padding-top:2px}", ""]);
// Exports
module.exports = exports;
